/**
 * 登录返回 shouldShowQuestionnaire=1 时写入 sessionStorage，
 * 刷新后由 App 消费并弹出调研问卷（避开考试页）。
 */
const STORAGE_KEY = 'bloom:shouldShowQuestionnaire'

/** 考试相关路由：按 PRD 不弹问卷 */
const EXAM_PATH_RE = /\/ExamSystem|\/waitingExamination/i

export function markBloomSurveyPending (loginData) {
  if (loginData && Number(loginData.shouldShowQuestionnaire) === 1) {
    sessionStorage.setItem(STORAGE_KEY, '1')
  }
}

export function hasBloomSurveyPending () {
  return sessionStorage.getItem(STORAGE_KEY) === '1'
}

export function clearBloomSurveyPending () {
  sessionStorage.removeItem(STORAGE_KEY)
}

function isExamRoute (route) {
  if (!route) return false
  const path = route.path || ''
  const name = route.name || ''
  return EXAM_PATH_RE.test(path) || EXAM_PATH_RE.test(String(name))
}

/**
 * 消费待弹标记并打开调研弹窗。
 * 考试页保留标记，离开考试后再弹；非学生直接清标记。
 */
export function tryShowBloomSurveyDialog (vm) {
  if (!vm || !hasBloomSurveyPending()) return false
  if (isExamRoute(vm.$route)) return false

  let userData = null
  try {
    userData = JSON.parse(vm.$utils.cache('userData'))
  } catch (e) {
    userData = null
  }
  // 仅学生（userType === 0）弹出
  if (!userData || Number(userData.userType) !== 0) {
    clearBloomSurveyPending()
    return false
  }

  clearBloomSurveyPending()
  if (typeof vm.$_BloomSurveyDialog === 'function') {
    vm.$nextTick(() => {
      vm.$_BloomSurveyDialog()
    })
    return true
  }
  return false
}



// WEBPACK FOOTER //
// ./src/plugin/BloomSurveyDialog/pending.js